export enum RosterDeliveryResourceType {
  Fahrzeug = 'VEHICLE',
  Vkforg = 'VKFORG',
}
